export default __webpack_public_path__ + "static/media/addIcon.bb96193f.svg";